import { Component, Input, OnInit } from '@angular/core';
import { OperationTraceDTO } from '@app/requests/model/requests-model';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';

@Component({
  selector: 'scf-traces',
  templateUrl: './traces.component.html',
  styleUrls: ['./traces.component.scss'],
})
export class TracesComponent implements OnInit {
  @Input() numOperation: string = '';
  dataTraces: OperationTraceDTO;
  loaded = false;

  constructor(private requestGeyDataApi: RequestsGetDataApi) {}

  ngOnInit(): void {
    this.requestGeyDataApi.postOperationTraces(this.numOperation).subscribe((data) => {
      this.dataTraces = data;
      this.loaded = true;
    });
  }
}
